import("./bootstrap").catch((err) => console.error(err));
(window as any).ngDevMode = false;
